import React from 'react';

const Sobremi = () => {
    return (
        <div className="container max-w-screen-lg mx-auto p-4 bg-black min-h-screen">
            {/* Título centrado en la parte superior */}
            <h1 className="text-4xl font-extrabold py-6 text-white text-center border-b-2 border-gray-700">
                Sobre Mí
            </h1>

            {/* Cuerpo dividido en dos secciones: imagen arriba en móviles, lado izquierdo en escritorio */}
            <div className="flex flex-col lg:flex-row mt-10 gap-8 items-center">
                {/* Sección izquierda para imagen */}
                <div className="w-full lg:w-1/2 flex items-center justify-center">
                    <img src="/avatar.png" alt="image" className="rounded-full w-40 h-40 lg:w-52 lg:h-52" />
                </div>

                {/* Sección derecha para texto */}
                <div className="w-full lg:w-1/2 p-4 text-white text-center lg:text-left">
                    <h2 className="text-3xl font-bold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500">
                        Acerca de mí
                    </h2>
                    <p className="text-gray-300 leading-relaxed text-sm mb-1">
                        Profesional con fuertes habilidades analíticas, experiencia en gestión de proyectos y dominio del inglés (B2).
                        Destaco por mi adaptabilidad, capacidad para trabajar bajo presión y mi constante búsqueda de nuevos desafíos y habilidades.
                    </p>
                    <div className="mt-4">
                        <h3 className="text-2xl font-semibold mb-1 text-gray-100">Tecnologías</h3>
                        <ul className="list-disc list-inside text-gray-400 space-y-3 text-sm">
                            <li>Fullstack - Big Data - AI - Cybersecurity - Data Analysis</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sobremi;
